import axios from "axios";
import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { env } from "../config";
import * as Actions from "../redux/actions";
import Loader from "../components/Loader";
import Footer from "../components/Footer";

const AiIntro = lazy(() => import("../components/AiPageIntroSection"));
const ContactUsSection = lazy(() => import("../components/ContactUsSection"));
const AiPlatformCards = lazy(() => import("../components/AiPlatformCards"));
const AiPlatformFeatures = lazy(
  () => import("../components/AiPlatformFeatures")
);
const OrchestrationPlatform = lazy(
  () => import("../components/AiOrchestrationPlatform")
);

export interface AiPageData {
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  AiPageIntro: AiPageIntro;
  CardsSection: CardsSection;
  PlatformFeaturesCards: PlatformFeaturesCards;
  ContactUsSection: ContactUsSection;
  OrchestrationPlatform: OrchestrationPlatform;
}

export interface AiPageIntro {
  id: number;
  Description1: string;
  Description2: any;
  introCards: { Title: string; Description: string; image: Image }[];
  ButtonText: any;
  Title1: string;
  Title2: string;
  Description3: any;
  Image: Image;
}

export interface Image {
  data: any;
}

export interface CardsSection {
  id: number;
  Title: string;
  Description: string;
  ButtonText1: any;
  ButtonText2: any;
  Cards: Card[];
}

export interface Card {
  id: number;
  Title: string;
  Description: string;
  buttonText: any;
  buttonLink: any;
  Image: Image2;
}

export interface Image2 {
  data: any;
}

export interface PlatformFeaturesCards {
  id: number;
  Title: string;
  Description: any;
  ButtonText1: string;
  ButtonText2: any;
  Cards: Card2[];
}

export interface Card2 {
  id: number;
  Title: string;
  Description: string;
  buttonText: string;
  buttonLink: any;
  Image: Image3;
}

export interface Image3 {
  data: any;
}

export interface ContactUsSection {
  id: number;
  Title: string;
  Description: string;
  ButtonText: string;
}

export interface OrchestrationPlatform {
  id: number;
  Title: string;
  Description: string;
  ButtonText1: any;
  ButtonText2: any;
  Cards: Card3[];
}

export interface Card3 {
  id: number;
  Title: string;
  Description: string;
  buttonText: any;
  buttonLink: any;
  Image: Image4;
}

export interface Image4 {
  data: any;
}

const Ai = () => {
  const AiPageData = useSelector(
    (state: any) => state?.Page?.AiPageData
  ) as AiPageData;
  let url = "/api/ai-page-content?populate=deep";
  let action = Actions.AiPageAction;

  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(AiPageData).length === 0) {
      setTimeout(() => {
        (async () => {
          await axios
            .get(`${env}${url}`)
            .then(function (response) {
              dispatch(action(response?.data?.data?.attributes));
            })
            .catch((error: any) => {
              console.log("error", error);
            });
        })();
      }, 0);
    }
    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, [dispatch]);

  const isLoading = Object.keys(AiPageData).length === 0;

  return (
    <Suspense fallback={<Loader />}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <AiIntro
            imagePosition="mx-auto object-contain"
            cardsSection={AiPageData?.AiPageIntro?.introCards}
            altText="Ai Development"
            AiPageIntro={AiPageData?.AiPageIntro}
          />
          <AiPlatformCards
            Features={AiPageData?.CardsSection?.Cards}
            Description={AiPageData?.CardsSection?.Description}
            title={AiPageData?.CardsSection?.Title}
          />
          {/* <AiPlatformFeatures
            Features={AiPageData?.PlatformFeaturesCards?.Cards}
            Description={AiPageData?.PlatformFeaturesCards?.Description}
            title={AiPageData?.PlatformFeaturesCards?.Title}
          /> */}
          <OrchestrationPlatform
            Features={AiPageData?.OrchestrationPlatform?.Cards}
            Description={AiPageData?.OrchestrationPlatform?.Description}
            title={AiPageData?.OrchestrationPlatform?.Title}
          />
          <ContactUsSection ContactUsSection={AiPageData?.ContactUsSection} />
          <Footer />
        </>
      )}
    </Suspense>
  );
};

export default Ai;
